import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "general__radio_checked",
  "use": "general__radio_checked-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"general__radio_checked\">\n  <circle cx=\"16\" cy=\"16\" fill=\"none\" r=\"15.5\" />\n  <circle cx=\"16\" cy=\"16\" r=\"13\" stroke=\"none\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol